import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderStyleComponent } from "./med-icon-border-style.component";

@NgModule({
  declarations: [
    MedIconBorderStyleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderStyleComponent,
  ],
})
export class MedIconBorderStyleModule { }
